import React, { useState, useEffect } from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import styled from 'styled-components';

import { NewList } from '../components/list/NewList';
import { ListList } from '../components/list/List';
import { Loading } from '../components/Loading';

const db = firebase.firestore();

export function List() {
  const [lists, setLists] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const { user } = useAuthState(firebase.auth());

  useEffect(() => {
    const fetchData = async () => {
      const userDoc = await db.doc(`users/${user.uid}`).get();
      const { householdUid } = userDoc.data();
      try {
        const listCollection = await db
          .collection('lists')
          .where('householdUid', '==', householdUid)
          .orderBy('time', 'desc')
          .limit(10)
          .get();
        const finalList = listCollection.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        if (listCollection) {
          setListLoading(false);
          setLists(finalList);
        }
      } catch (err) {
        console.log(err.message);
      }
    };

    fetchData();
  }, []);
  return (
    <>
      <NewList />
      <H2>Your lists</H2>
      {listLoading && <Loading />}
      {lists && (
        <>
          {lists.map(({ id, store, time, items }) => {
            return (
              <ListList
                storeName={store && store.address && store.address.name}
                listId={id}
                key={id}
                count={items && items.length}
                time={time}
              />
            );
          })}
        </>
      )}
    </>
  );
}

const H2 = styled.h2`
  font-family: sans-serif;
  font-weight: bold;
  margin-top: 30px;
`;
